export default __webpack_public_path__ + "static/media/Sueli Andrade_.cd020053.png";